import { get, post } from "@/utils/http";
// import contentType from "@/utils/content-type";

let baseURL = "/organation";
const tree = () => get(`${baseURL}/tree`);

const serrchTree = data => get(`${baseURL}/getSearchOrganationTree`, data);

const updateOrganation = data => post(`${baseURL}/update`, { data });

const deleteOrganation = data => get(`${baseURL}/delete`, data);

const updateOrganizationSort  = data => post(`${baseURL}/updateOrganizationSort`, { data });

// 查询所有用户信息
const getAllOrganation = () => get(`${baseURL}/getAllList`);

// userAPI
export default {
  getAllOrganation,
  tree,
  serrchTree,
  deleteOrganation,
  updateOrganation,
  updateOrganizationSort
};
